/**
 * Turns plain in-app <a href="/..."> clicks into client-side navigation so
 * going "Home"/back between portals never reloads the page (no loading
 * screen, no refetch of everything). External links, new-tab clicks,
 * downloads and target=_blank anchors behave as before.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SpaLinkInterceptor() {
  const navigate = useNavigate();
  useEffect(() => {
    function onClick(e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest?.('a[href]');
      if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
      const raw = a.getAttribute('href');
      if (!raw || raw.startsWith('#') || /^(mailto|tel|blob|data):/i.test(raw)) return;
      let url;
      try { url = new URL(a.href, window.location.href); } catch (_) { return; }
      if (url.origin !== window.location.origin) return;
      e.preventDefault();
      navigate(url.pathname + url.search + url.hash);
    }
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [navigate]);
  return null;
}
